import React from 'react';
import { PropTypes } from "prop-types";

const NipDisabled = ({
    type,
    label,
    placeholder,
    detail,
    field,
    form,
    onChange,
    onBlur,
    name,
    onFocus,
}) => {
    return (
        <div>
            <div className="nip-input-container">
                <label className="form-label2">{label}</label>
                <p className="form-details">{detail}</p>
                <input
                    type={type}
                    placeholder={placeholder}
                    onFocus={onFocus}
                    onChange={(field && field.onChange) || onChange}
                    onBlur={(field && field.onBlur) || onBlur}
                    value={(field && field.value) || ''}
                    name={(field && field.name) || name}
                    className="form-input3"
                    readOnly
                />
            </div>
            {form && form.touched[field.name] && form && form.errors[field.name] && (
                <small className="errors">{form.errors[field.name]}</small>
            )}
        </div>
    )
}

NipDisabled.propTypes = {
  detail: PropTypes.any,
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.any,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string
}

export default NipDisabled;